import { useMemo } from 'react';
import { skipToken, useResource } from 'pulse/react';

// @ts-ignore Untyped Dependency
import { getCurrentThreadId } from '../../thread-history/selectors/getCurrentThreadId';
import { getSessionId } from '../../selectors/widgetDataSelectors/getSessionId';
import { ResolveThreadAttachments } from '../resources/resolveThreadAttachmentsResource';
import { signedUrlToFileMetadata } from '../operators/signedUrlToFileMetadata';
import { useAppSelector } from '../../buildStore';

// Resolves the given file ids for the current thread into plain `FileMetadata`
// objects. The thread id and session id are widget-global, so callers only need
// to supply the file ids for the message(s) being rendered.
export function useResolvedFileAttachments(fileIds) {
  const threadId = useAppSelector(getCurrentThreadId);
  const sessionId = useAppSelector(getSessionId);
  const params = fileIds.length === 0 || threadId == null || !sessionId ? skipToken : {
    threadId,
    sessionId,
    fileIds: [...fileIds].sort((a, b) => a - b)
  };
  const {
    data
  } = useResource(ResolveThreadAttachments, {
    params
  });
  return useMemo(() => {
    if (!data) {
      return [];
    }
    return Object.values(data).reduce((accumulator, entry) => {
      const metadata = signedUrlToFileMetadata(entry);
      if (metadata) {
        accumulator.push(metadata);
      }
      return accumulator;
    }, []);
  }, [data]);
}